import React from "react";
// import HttpService from '../../utils/Http.services';
import { siteConfig, siteTheme } from "../../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../../components/Configurer";
import ProfileImage from "../../components/partials/ProfileImage";
import TableViewer from "../../components/TableViewer";
// import { v4 as uuidv4 } from 'uuid';
import ItemModal from "../../modals/ItemModal";
import HttpServices from "../../utils/Http.services";
import RemoveModal from "../../modals/RemoveModal";
import { checkPermission, checkTextTranslation, checkTranslation, imageAddress, pathMaker, phoneStandardView, translate } from "../../utils/useful";
import { getWorkflowDocumentFile } from '../../utils/workflowDocumentActions';
import FilterModal from "../../modals/FilterModal";
import Pagination from "../../components/Pagination";
import OptionsListModal from "../../modals/OptionsListModal";
import Loader from 'react-loader-spinner'
import Modal from "../../components/Modal";
import { saveAs } from 'file-saver';
// import { adminPages } from "../../variables/adminPages";
import ImportModal from "../../modals/ImportModal";
import { isLocalRolePreviewSession } from "../../utils/localRolePreview";

export class AdminFormApplet extends React.Component {

    isLocalPreviewMode(props = this.props) {
        return props.localPreview === true
            && Array.isArray(props.previewRecords)
            && isLocalRolePreviewSession(props.user?.info)
    }

    getPreviewRecordsSignature(props = this.props) {
        if (!this.isLocalPreviewMode(props)) return ''

        return props.previewRecords.map(record => {
            return record?._id || record?.id || ''
        }).join('|')
    }

    loadPreviewRecords = () => {
        const previewRecords = Array.isArray(this.props.previewRecords)
            ? this.props.previewRecords.slice()
            : []

        this.setState({
            data: previewRecords,
            totalCount: previewRecords.length,
            showTable: true,
            isLoadingData: false,
        })
    }


    openEditModal = (prop, index) => {
        if (this.isLocalPreviewMode()) return

        // this.itemModal.modal.showModal()
        // console.log('this.props.page.key', prop)
        // console.log('this.props.page.key', this.props.page.key)
        // this.setState({ currentItem: prop, currentIndex: index })
        if (this.props.page?.addNew && this.props.page?.addNew != -1) {
            let id = prop._id ?? prop.id
            let plannedId
            if (this.props.page.key == 'recordtheresult') {
                plannedId = prop.plannedId
            }
            if (this.props.page?.addNew?.function) {
                if (this[this.props.page?.addNew?.function]) {
                    this[this.props.page?.addNew?.function]()
                }

            } else if (this.props.page?.addNew?.page) {
                let newPage = this.props.route + this.props.page?.addNew.page
                // if()
                if (this.props.page.key == 'recordtheresult' && plannedId) {


                    this.props.history.push(pathMaker(newPage + '?id=' + id + '&plannedId=' + plannedId + '&ref=/' + pathMaker(this.props.baseUrl.join('/') + '/' + this.props.page?.key)))
                } else {
                    this.props.history.push(pathMaker(newPage + '?id=' + id + '&ref=/' + pathMaker(this.props.baseUrl.join('/') + '/' + this.props.page?.key)))

                }
            }
            else {
                let newPage = this.props.page?.addNew
                if (this.props.page?.addNew?.includes('../')) {
                    newPage = '/' + (this.props.baseUrl.join('/')) + this.props.page?.addNew.replace('..', '')
                }

                // console.log(newPage)
                // window.history.pushState({}, '', pathMaker(newPage));


                // this.props.history.push({ pathname: pathMaker(newPage), search: '?ref=' + pathMaker('/' + this.props.route + '/' + this.props.page?.key), state: { isAdmin: true } })
                if (this.props.page.key == 'recordtheresult' && plannedId) {


                    window.history.pushState({}, '', pathMaker(newPage + '?id=' + id + '&plannedId=' + plannedId + '&ref=/' + pathMaker(this.props.baseUrl.join('/') + '/' + this.props.page?.key)))
                }
                else if (this.props.page.key == 'recordtheresult') {
                    // console.log('checkviewRecordtheresult', true)
                    window.history.pushState({}, '', pathMaker(newPage + '?id=' + prop.nonComplianceId + '&plannedId=' + id + '&ref=' + pathMaker(this.props.route + '/' + this.props.page?.key)))
                }
                else {
                    window.history.pushState({}, '', pathMaker(newPage + '?id=' + id + '&ref=/' + pathMaker(this.props.baseUrl.join('/') + '/' + this.props.page?.key)))
                }
            }
        } else {
            this.itemModal.modal.showModal()
            this.setState({ currentItem: prop, currentIndex: index })
        }
    }

    openRemoveModal = (prop, index) => {
        if (this.isLocalPreviewMode()) return

        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }
    openImport = () => {
        this.ImportModal.modal.showModal()
    }
    showDetails = (prop, index) => {
        this.setState({ showDetails: true })
        // this.removeModal.modal.showModal()
        // this.setState({ currentItem: prop, currentIndex: index })
    }

    state = {
        data: [],
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#fff', bg: '#10453d', function: this.openEditModal, permission: ['view'] },
            remove: { key: "remove", label: '{{lang}}remove', color: '#fff', bg: '#d91111', function: this.openRemoveModal, permission: ['delete'] }
        },
        extraItems: [],
        currentPage: 0,
        limit: 50,
        options: [
            // { name: 'Export', icon: '/images/eye.svg', function: this.openExport },
            // { name: 'Edit', icon: '/images/settings.svg', function: this.openEdit },
            // { name: 'Connect', icon: '/images/settings.svg', function: this.fetchConnect },
            // { name: 'Remove', description: 'remove this data', icon: '/images/remove.svg', function: this.openRemoveModal },
        ]
    }


    componentDidMount() {
        this.init()
        window.addEventListener('reloadFetchData', this.handleReloadFetchData)
    }

    handleReloadFetchData = () => {
        if (this.isLocalPreviewMode()) return

        this.fetchData(true)
    }

    componentWillUnmount() {
        window.removeEventListener('reloadFetchData', this.handleReloadFetchData)
    }

    componentDidUpdate(prevProps) {
        const isLocalPreview = this.isLocalPreviewMode()
        const wasLocalPreview = this.isLocalPreviewMode(prevProps)
        const pageChanged = this.getPageRequestIdentity() !== this.getPageRequestIdentity(prevProps)

        if (pageChanged && this.props.page?.pageType == 'form') {
            // setTimeout(() => {

            this.init()
            // }, 500);
        } else if (isLocalPreview !== wasLocalPreview) {
            this.init()
        } else if (
            isLocalPreview
            && (
                this.getPreviewRecordsSignature() !== this.getPreviewRecordsSignature(prevProps)
                || this.props.viewerUserType !== prevProps.viewerUserType
            )
        ) {
            this.loadPreviewRecords()
        }
        // if (this.props.page !== prevProps.page && this.props.page && this.props.page.pageType == 'table') {
        //     // setTimeout(() => {
        //     this.init()
        //     this.setState({ currentPage: 0 })
        //     // }, 500);
        // }
    }

    getPageRequestIdentity = (props = this.props) => {
        const page = props.page
        if (!page) return ''

        return [
            page.key,
            page.page,
            page.fetchUrl,
            page.pageType,
            props.user?.info?._id,
            props.applet,
        ].filter(value => value != null).join('|')
    }

    init() {
        if (this.props.page) {
            this.setState({ showTable: false, selectedTab: null, data: [], totalCount: null, filters: null, filter: {}, filter2: {} }, () => {
                if (this.isLocalPreviewMode()) {
                    this.loadPreviewRecords()
                } else {
                    this.fetchData(true)
                }
            })
        }
    }

    fetchData = (getCount) => {
        if (this.isLocalPreviewMode()) {
            this.loadPreviewRecords()
            return
        }


        // console.log("fetchData", this.props.page)
        this.setState({ isLoadingData: true })
        let page = this.props.page

        if (page.pageType != "form") {
            this.setState({ isLoadingData: false })
            return
        }

        // Build an isolated request so shared page configuration is never
        // mutated between renders or pagination/filter updates.
        let body = { ...(page.filter ?? {}) }

        body.limit = this.state.limit
        body.skip = this.state.currentPage

        // body.active = 0

        body.filter = { ...(this.state.filter ?? {}) }

        if (this.state.filter2) {
            body.filter2 = { ...this.state.filter2 }
        }

        if (this.props.page.postBody) {
            body.filter = { ...body.filter, ...this.props.page.postBody }
        }

        if (this.props.page.populate) {
            body.populate = this.props.page.populate
        }

        if (this.props.page.sort) {
            body.sort = this.props.page.sort
        }

        // console.log(this.props.variables)
        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }

        for (const [key, value] of Object.entries(body.filter)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body.filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }

        if (this.state.totalCount == null || getCount) {
            body.getCount = true
        }

        // console.log(body)
        // console.log(page.fetchUrl)
        let search = window.location.search;
        // console.log('searchis ', search)
        let params = new URLSearchParams(search);
        body.id = params.get('id')
        // console.log('page.fetchUrl', page.fetchUrl, body)
        body.page = page.page ?? page.key
        body.frame = page.page ?? page.key

        if (page.populates) {
            body.populates = page.populates
        }

        if (this.props.applet) {
            body.applet = this.props.applet
        }

        HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
            if (fetchError) {
                this.setState({ isLoadingData: false })
                this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errors.loadDataFailed'), description: checkTranslation(fetchError.message) })
                return
            }

            this.setState({
                data: Array.isArray(fetchResult?.info) ? fetchResult.info : [],
                showTable: true,
                isLoadingData: false,
                ...(fetchResult?.count != null ? { totalCount: fetchResult.count } : {}),
            })
        })
    }


    openRefModal = (prop, index, reference) => {
        // console.log("openRefModal")
        // console.log(reference)
        let page = this.props.pages[reference.ref]

        let _id = typeof prop == 'object' ? prop._id : prop

        let body = { filter: { _id } }

        if (page?.page) {
            body.filter = { ...{ page: page.key, _id }, ...body.filter }
        }


        // console.log(body)
        HttpServices.request(page.fetchOne, body, (fetchResult, fetchError) => {
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errors.loadDataFailed'), description: checkTranslation(fetchError.message) })
                return
            }

            let newItem = { page, data: fetchResult.info }
            let extraItems = this.state.extraItems
            extraItems.push(newItem)
            this.setState({ extraItems }, () => {
                setTimeout(() => {
                    this['itemModal' + String(extraItems.length - 1)].modal.showModal()
                }, 10);
            })

        })
        // console.log(object.key)

    }


    changePage = (index) => {
        this.setState({ currentPage: index }, () => {
            this.fetchData()
        })
    }


    fetchRemove = () => {
        if (this.isLocalPreviewMode()) return

        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        // console.log(id)
        // console.log(this.props.page.removeUrl)
        HttpServices.request(this.props.page.removeUrl, { "id": id, page: this.props.page.page ?? this.props.page.key }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })
            // console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}Remove Failed'), description: checkTranslation(fetchError.message) })
                return
            }
            let data = this.state.data
            data.splice(this.state.currentIndex, 1)
            this.setState({ data })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: checkTranslation('{{lang}}Removed'), description: checkTranslation('{{lang}}Removed Record Successfully') })


        })

    }



    fetchExport = () => {

        let body = this.props.page.filter ?? {}; let page = this.props.page
        body.page = page.key; body.limit = this.state.limit; body.skip = this.state.currentPage; body.filter = this.state.filter ?? {}
        // body.page = page.key

        if (this.state.filter2) body.filter2 = this.state.filter2

        if (this.props.page.postBody) body.filter = { ...body.filter, ...this.props.page.postBody }
        // if (this.props.page?.extra?.export?.filter) body.filter = { ...body.filter, ...this.props.page?.extra?.export?.filter }

        if (this.props.page.populate) body.populate = this.props.page.populate

        if (this.props.page.sort) body.sort = this.props.page.sort


        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }

        for (const [key, value] of Object.entries(body.filter)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body.filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }

        // if (this.state.totalCount == null || getCount) body.getCount = true

        body.headers = this.props.page.headers
        body.populate = this.props.page.populates

        HttpServices.request(this.props.page?.extra?.export?.url, body, (fetchResult, fetchError) => {
            // this.setState({ isLoadingRemove: false })
            // console.log(fetchError)
            // console.log(fetchResult)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}errors.removeFailed'), description: checkTranslation(fetchError.message) })
                return
            }
            // let data = this.state.data
            // data.splice(this.state.currentIndex, 1)
            // this.setState({ data })
            // console.log(siteConfig.assetsDomain + fetchResult.info)
            saveAs(siteConfig.assetsDomain  + fetchResult.info)

            this.exportModal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: checkTranslation('{{lang}}info.removedSuccesfully'), description: checkTranslation('{{lang}}info.dataRemovedSuccessfully') })
        })
    }


    itemAdded = (newItem, modalIndex) => {
        // console.log(newItem)

        if (newItem && modalIndex == null) {
            let data = this.state.data
            data.splice(0, 0, newItem)
            // console.log(newItem)
            // console.log(data)
            this.setState(data)
        } else {
            this.fetchData(true)
        }
    }

    itemEdited = (editedItem, id, modalIndex) => {
        // console.log(editedItem)
        if (modalIndex == null) {
            let data = this.state.data
            this.state.data.forEach((element, index) => {
                let id = element.id ?? element._id
                let currentId = this.state.currentItem.id ?? this.state.currentItem._id
                if (id === currentId) {
                    // console.log(id)
                    data[index] = Object.assign({}, editedItem)
                }
            })
            this.setState({ data }, () => {
                // console.log(editedItem)
                // console.log(data)
                // this.TableViewer.forceUpdateData()
            })
        } else {
            this.fetchData()
        }
    }

    updateData = (data) => {
        this.setState(data)
    }


    openAddNew = () => {
        if (this.isLocalPreviewMode()) return

        // console.log(this.props.page)
        // console.log("openAddNew2", this.props.page)
        if (this.props.page?.addNew) {
            let newPage = this.props.page?.addNew
            if (this.props.page?.addNew.includes('../')) {
                newPage = '/' + (this.props.baseUrl.join('/')) + this.props.page?.addNew.replace('..', '')
            }
            // console.log(newPage)

            window.history.pushState({}, '', pathMaker(newPage + '?ref=/' + pathMaker(this.props.baseUrl.join('/') + '/' + this.props.page?.key)));

            // console.log(newPage)
            // this.props.history.push({ pathname: pathMaker(newPage), search: '?ref=' + pathMaker('/' + this.props.route + '/' + this.props.page?.key), state: { isAdmin: true } })
        } else {
            this.openEditModal()
        }
    }

    openFilterModal() {
        this.filterModal.showModal()
    }

    doFilter = (data) => {
        // console.log(data)
        this.setState({ currentPage: 0, filter2: data }, () => {
            this.fetchData(true)
            this.filterModal.modal.hideModal()

        })
    }

    filterLabelCreator(rawprop) {
        let prop = JSON.parse(JSON.stringify(rawprop))
        // console.log(prop)
        let isArray = false
        if (Array.isArray(prop.value)) {
            isArray = true
        }

        // let label
        let value = prop.value
        if (prop.type == 'PhoneInput') {
            value = phoneStandardView(value)
        }


        if (prop.dictionary) {

            if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i++) {
                    const element = value[i];
                    if (prop.dictionary[element]) {
                        value[i] = prop.dictionary[element]
                    }
                }
            } else {
                if (prop.dictionary[value]) {
                    value = prop.dictionary[value]
                }
            }
        }

        let label = checkTranslation(prop.label) + ' ' + prop.operator + ' ' + value


        return label
    }

    removeFilter = (prop) => {
        let filter2 = this.state.filter2
        delete filter2[prop.key]
        // console.log(filter)
        this.setState({ filter2 }, () => {
            this.fetchData(true)
        })
    }


    openOptions = (prop, index) => {
        // console.log(prop)

        let options = []

        Object.values(this.props.page?.extra).forEach(element => {
            let option = { ...element }
            option.function = this[option.function]
            options.push(option)
        });
        console.log(options)
        // { name: 'Export', icon: '/images/eye.svg', function: this.openExport },
        // { name: 'Edit', icon: '/images/settings.svg', function: this.openEdit },
        // { name: 'Connect', icon: '/images/settings.svg', function: this.fetchConnect },
        // { name: 'Remove', description: 'remove this data', icon: '/images/remove.svg', function: this.openRemoveModal },
        // ]

        this.setState({ options, currentItem: prop, currentIndex: index }, () => {
            this.optionsModal.modal.showModal()
        })

    }

    translateStage = (stage) => {
        let translatedStage
        switch (stage) {
            case 'initialReview':
                translatedStage = '{{lang}}Initial inspection'
                break;

            case 'userRootting':
                translatedStage = '{{lang}}Rootting'
                break;

            case 'userPlanning':
                translatedStage = '{{lang}}Planning'
                break;

            case 'conclusion':
                translatedStage = '{{lang}}Conclusioning'
                break;

            case 'userEffectiveness':
                translatedStage = '{{lang}}Effectiveness'
                break;

            case 'recordResult':
                translatedStage = '{{lang}}Result record'
                break;

            case 'correction':
                translatedStage = '{{lang}}Correction'
                break;

            case 'done':
                translatedStage = '{{lang}}Terminated'
                break;

            case 'Done':
                translatedStage = '{{lang}}Terminated'
                break;

            case 'reject':
                translatedStage = '{{lang}}Rejected'
                break;

            default:
                translatedStage = stage
                break;
        }
        return translatedStage
    }

    downloadFinancialPDF = (prop, index, reference) => {

        let body = { _id: prop._id }
        // console.log(body)
        this.exportModal.showModal()

        HttpServices.request('getInvoicePDF', body, (fetchResult, fetchError) => {
            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}Email Failed'), description: checkTranslation(fetchError.message) })
                return
            }

            console.log(fetchResult)

            this.exportModal.hideModal()

            if (fetchResult.file) {

                saveAs(siteConfig.assetsDomain + 'assets/pdfs/' + fetchResult.file)

                this.props.actions.addNotif({ type: 'success', title: checkTranslation('{{lang}}PDF Created Successfuly'), description: checkTranslation('{{lang}}Email sent successfully') })

                // let url = assetsUrl + 'pdfs/' + data.file
                // window.open(url, '_blank');
                // console.log()
            }

            // saveAs(siteConfig.assetsDomain + fetchResult.info)

            // this.exportModal.hideModal()
        })

    }

    sendFinancialEmail = (prop, index, reference) => {

        let body = { _id: prop._id }
        console.log(body)
        HttpServices.request('sendInvoiceEmail', body, (fetchResult, fetchError) => {
            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: checkTranslation('{{lang}}Email Failed'), description: checkTranslation(fetchError.message) })
                return
            }

            // saveAs(siteConfig.assetsDomain + fetchResult.info)

            // this.exportModal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: checkTranslation('{{lang}}Email Sent'), description: checkTranslation('{{lang}}Email sent successfully') })
        })

    }



    openExport = () => {
        this.exportModal.showModal()
        this.fetchExport()
        // console.log("TEST")
    }

    changeTab = (index, prop) => {
        this.setState({ selectedTab: index })
        this.setState({ currentPage: 0, filter: prop ? prop.filter : {} }, () => {
            this.fetchData(true)
        })
    }

    functionsHandler = (prop, index, reference) => {
        console.log("functionsHandler3")
        // console.log(reference)
        // console.log(prop)
        if (this[reference.function]) {
            this[reference.function](prop, index, reference)
        }

    }

    getTableActions = () => {
        const tableActions = this.props.page?.actions ?? this.state.actions
        if (!this.isLocalPreviewMode()) return tableActions

        return Object.fromEntries(
            Object.entries(tableActions || {}).filter(([, action]) => {
                return action?.function === 'openStatusModal'
            })
        )
    }

    handleRecordUpdated = (updatedRecord) => {
        if (!this.isLocalPreviewMode()) return

        const updatedId = updatedRecord?._id || updatedRecord?.id
        if (!updatedId) return

        this.setState(previousState => ({
            data: previousState.data.map(record => {
                const recordId = record?._id || record?.id
                return recordId === updatedId ? updatedRecord : record
            }),
        }))
    }

    openStatusModal = (rowData, index, action) => {
        // Store the row data that should show the status modal
        this.setState({ statusModalRowId: rowData._id || rowData.id }, () => {
            // Trigger a custom event or use a ref to open the modal
            // Since we can't directly access the table component, we'll use a different approach
            // The table component will check for this state via a prop or we'll use a global event
            window.dispatchEvent(new CustomEvent('openStatusModal', { detail: { rowId: rowData._id || rowData.id } }))
        })
    }

    downloadWorkflowDocument = async (rowData, index, action) => {
        const file = getWorkflowDocumentFile(rowData, action?.documentField)
        if (!file?.address) return

        try {
            const response = await fetch(imageAddress(file))
            if (!response.ok) throw new Error('Download failed')
            const blob = await response.blob()
            const signature = await blob.slice(0, 5).text()
            if (!signature.startsWith('%PDF-')) throw new Error('Invalid PDF')
            saveAs(blob, file.originalName || action?.downloadName || `${action.documentField}.pdf`)
        } catch (_) {
            this.props.actions.addNotif({
                type: 'error',
                title: checkTranslation('{{lang}}Download Failed'),
                description: checkTranslation('{{lang}}The PDF could not be downloaded'),
            })
        }
    }

    exportRecordPdf = (rowData) => {
        if (!rowData?._id || this.isLocalPreviewMode()) return

        this.exportModal?.showModal()
        HttpServices.request('exportRecordPdf', { _id: rowData._id }, (fetchResult, fetchError) => {
            this.exportModal?.hideModal()
            if (fetchError || !fetchResult?.file) {
                this.props.actions.addNotif({
                    type: 'error',
                    title: checkTranslation('{{lang}}PDF export failed'),
                    description: checkTranslation(fetchError?.error || fetchError?.message || '{{lang}}The record PDF could not be created'),
                })
                return
            }

            try {
                const binary = window.atob(fetchResult.file)
                const bytes = new Uint8Array(binary.length)
                for (let position = 0; position < binary.length; position += 1) {
                    bytes[position] = binary.charCodeAt(position)
                }
                const signature = String.fromCharCode(...bytes.slice(0, 5))
                if (signature !== '%PDF-') throw new Error('Invalid PDF response')
                const blob = new Blob([bytes], { type: fetchResult.mime || 'application/pdf' })
                saveAs(blob, fetchResult.filename || `IHP-${rowData.values?.formId || rowData._id}.pdf`)
                this.props.actions.addNotif({
                    type: 'success',
                    title: checkTranslation('{{lang}}PDF created successfully'),
                    description: checkTranslation('{{lang}}The record PDF was downloaded'),
                })
            } catch (_) {
                this.props.actions.addNotif({
                    type: 'error',
                    title: checkTranslation('{{lang}}PDF export failed'),
                    description: checkTranslation('{{lang}}The record PDF could not be created'),
                })
            }
        })
    }

    render() {
        return (

            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: checkTextTranslation(this.props.page?.title), button: { goBack: false } }}
                title={checkTextTranslation(this.props.page?.title)}
                description={checkTextTranslation(this.props.page?.description)}
                className=" "
            >
                <div className="container " >

                    <div className="row m-0 w-100 ">
                        <div className="col-12 p-0 mb-3" >
                            <div className="p-0" style={{ borderRadius: 0 }}>

                                <div className="flexcb" style={{ flexWrap: 'wrap' }}>

                                    <div className="flexc mt-4">

                                        <ProfileImage width={54} borderRadius={50} notif={0} border={'2px solid #eee'} className={'mrd-3'} data={{ image: this.props.page?.image ?? this.props.page?.icon }} />

                                        <div className="">
                                            <p className="" style={{ color: '#0d172a', fontSize: "17px" }}>{checkTranslation(this.props.page?.title)}</p>
                                            <p className="mt-2" style={{ color: '#89a', fontSize: "12px" }} >{this.state.totalCount ? (this.state.totalCount + translate("Records Found")) : checkTranslation(this.props.page?.description)}</p>
                                        </div>
                                    </div>


                                    <div className="flexcc mt-2" style={{}}>


                                        {this.props.page?.extra && (
                                            <button onClick={() => this.openOptions()} className="flexcc p-0" style={{ height: 28, width: 28, borderRadius: 30, flex: 1, boxShadow: '0px 0px 15px #00000005', color: '#789' }}>
                                                <img className="" src="/images/more.svg" alt="" width="24px" />
                                            </button>
                                        )}
                                        {!this.props.page?.hideFilter && (
                                            <button onClick={() => this.openFilterModal()} className="flexcc p-0 mrd-3" style={{ flex: 1, boxShadow: '0px 0px 15px #00000005', color: '#789' }}>
                                                {/* <img className=" " src="/images/search.svg" alt="" width="24px" /> */}
                                                {/* <span className="text-smaller m-0 white text-bold" >Filter</span> */}
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="" style={{ width: 30 }}>
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                                                </svg>

                                            </button>
                                        )}

                                        {(this.props.page?.addNew != -1 && (checkPermission(this.props.variables?.permissionRoot + '.create') || checkPermission(this.props.variables?.permissionParentRoot + '.create')) && !this.props?.page?.hideAddButton) && (
                                            <button
                                                onClick={() => this.openAddNew()}
                                                className="flexcc btn-animated"
                                                style={{
                                                    boxShadow: '0px 0px 18px rgba(16, 69, 61, 0.35)',
                                                    border: '0px solid #e9eaf0',
                                                    borderRadius: 30,
                                                    padding: '10px 26px'
                                                }}
                                            >
                                                <img className="mrd-2 invert" src="/images/add.svg" alt="" width="12px" />
                                                <span className="white" style={{ fontSize: "13px", fontWeight: "300" }}>{translate('Add New')}</span>
                                            </button>
                                        )}
                                    </div>
                                </div>


                                {this.state.filter2 && Object.values(this.state.filter2).length > 0 && (
                                    <div className="flexc mt-2 px-1">
                                        {Object.values(this.state.filter2).map((prop, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    className="flexcc mrd-1"
                                                    style={{
                                                        backgroundColor: 'rgba(226, 193, 158, 0.15)',
                                                        color: '#10453d',
                                                        borderRadius: 20,
                                                        padding: '3px 10px',
                                                        fontSize: 12
                                                    }}
                                                >
                                                    {this.filterLabelCreator(prop)}
                                                    <button
                                                        onClick={() => this.removeFilter(prop)}
                                                        className="p-0 mld-2"
                                                        style={{ color: '#10453d', fontSize: 12 }}
                                                    >
                                                        <span className="flexcc">X</span>
                                                    </button>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}

                            </div>

                        </div>

                        {this.props.page?.tabs && (

                            <div className="col-12  w-100 p-0">

                                <div className="flexc">

                                    <div className="ml-0" onClick={() => { this.changeTab(null) }} style={{ fontSize: 14, cursor: 'pointer', transition: 'all 0.5s', backgroundColor: this.state.selectedTab == null ? '#F87C56' : '#F87C56b7fb7f', borderRadius: '10px 10px 0px 0px', color: '#fff', padding: '4px 20px' }}>
                                        <p>All</p>
                                    </div>
                                    {this.props.page.tabs.map((prop, index) => {
                                        return (
                                            <div className="ml-0" onClick={() => { this.changeTab(index, prop) }} style={{ fontSize: 14, cursor: 'pointer', transition: 'all 0.5s', backgroundColor: this.state.selectedTab == index ? '#F87C56' : '#F87C56b7fb7f', borderRadius: '10px 10px 0px 0px', color: '#fff', padding: '4px 20px' }}>
                                                <p>{prop.title}</p>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )}

                        <div className="col-12 mb-5  w-100 p-0">

                            <TableViewer
                                isLoading={this.state.isLoadingData}
                                headers={this.props.page?.headers}
                                page={this.props.page}
                                data={this.state.data}
                                variables={this.props.variables}
                                actions={this.getTableActions()}
                                viewerUserType={this.props.viewerUserType}
                                onRecordUpdated={this.handleRecordUpdated}
                                settings={{ isSortable: false }}
                                openEditModal={this.openEditModal}
                                // openEditModal={this.openEditModal}
                                sendFinancialEmail={this.sendFinancialEmail}
                                openRemoveModal={this.openRemoveModal}
                                updateData={this.updateData}
                                functionsHandler={this.functionsHandler}
                                ref={el => this.TableViewer = el}
                            />

                        </div>

                        <div className="w-100  col-12 col-md-12 p-0">
                            <Pagination currentPage={this.state.currentPage} totalCount={this.state.totalCount} limit={this.state.limit} changePage={this.changePage} />
                        </div>


                    </div>



                    <FilterModal
                        ref={el => this.filterModal = el}
                        initData={this.state.filter2}
                        page={this.props.page}
                        headers={this.props.page?.headers}
                        doFilter={this.doFilter} />


                    <ItemModal
                        ref={el => this.itemModal = el}
                        page={this.props.page}
                        headers={this.props.page?.headers}
                        initData={this.state.currentItem}
                        variables={this.props.variables}
                        itemAdded={this.itemAdded}
                        itemEdited={this.itemEdited}
                        openRefModal={this.openRefModal}
                        functionsHandler={this.functionsHandler}
                        showDates={true}
                    />


                    {this.state.extraItems && this.state.extraItems.map((prop, index) => {
                        // console.log('admin.'+prop.page?.key)
                        return (

                            <ItemModal
                                ref={el => this["itemModal" + index] = el}
                                page={prop.page}
                                headers={prop.page?.headers}
                                initData={prop.data}
                                variables={{ ...{ permissionRoot: 'admin.' + prop.key }, ...this.props.variables }}
                                itemAdded={this.itemAdded}
                                itemEdited={this.itemEdited}
                                openRefModal={this.openRefModal}
                                functionsHandler={this.functionsHandler}

                                showDates={true}
                                modalIndex={index}
                            />

                        )

                    })}


                    <RemoveModal
                        isLoading={this.state.isLoadingRemove}
                        removeFunction={this.fetchRemove}
                        ref={el => this.removeModal = el}
                    />

                    <OptionsListModal ref={el => this.optionsModal = el}
                        options={this.state.options}
                    />
                    <ImportModal closeModal={() => this.ImportModal.modal.hideModal()} ref={el => this.ImportModal = el} data={this.state?.course} page={this.props.page} headers={this.props.page?.headers} colors={this.props.colors} />

                    <Modal ref={el => this.exportModal = el} maxWidth={300}>
                        <div className="pb-5 w-100 h-100">
                            <div className="w-100 h-100" style={{ backgroundColor: '#fff', overflow: 'auto', borderRadius: 8 }}>
                                <div
                                    className="w-100"
                                    style={{
                                        zIndex: 1,
                                        padding: '12px 22px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        borderBottom: '0px #eee solid',
                                        background: 'linear-gradient(135deg, #10453d 0%, #10453d 75%, #146a5d 100%)',
                                        backdropFilter: 'blur(10px) saturate(180%)',
                                        WebkitBackdropFilter: 'blur(10px) saturate(180%)',
                                        borderRadius: '8px 8px 0px 0px'
                                    }}
                                >

                                    <p className="text-bold mb-0 text-normal white ">Export</p>

                                    <div className="cursor-pointer" onClick={() => this.optionsModal.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <img style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
                                    </div>

                                </div>
                                <div className="py-4 px-3 pb-2 w-100 text-center">
                                    <Loader
                                        type="Oval"
                                        color="#789"
                                        height="50"
                                        width="50"
                                    />
                                    <p>Exporting in process ...</p>
                                    <p className="text-smaller" style={{ color: '#789' }}>Wait till it is completed</p>

                                </div>

                            </div>
                        </div>

                    </Modal>
                </div>
            </Configurer >
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminFormApplet);
